import { useState } from 'preact/hooks';
import type { PublicSession } from '../api/types';
import { isEmbedded, post } from '../embed-bridge';
import { t } from '../i18n';
import { applyTheme, type Theme } from '../main';
import { LanguageSwitch } from './LanguageSwitch';

export function Footer({ session }: { session: PublicSession }) {
  const [theme, setTheme] = useState<Theme>(
    (document.documentElement.getAttribute('data-theme') as Theme | null) ?? 'auto',
  );
  const cycle = () => {
    const next: Theme = theme === 'auto' ? 'dark' : theme === 'dark' ? 'light' : 'auto';
    setTheme(next);
    applyTheme(next);
  };
  const canCancel = session.status === 'pending' && (session.cancel_url || isEmbedded);
  return (
    <footer class="cv-footer">
      <span>{t('app.poweredBy')}</span>
      <div class="right">
        {canCancel &&
          (isEmbedded ? (
            <button
              type="button"
              class="cv-icon-btn"
              onClick={() => post({ source: 'coinvello', type: 'cancel', sessionId: session.id })}
            >
              {t('app.cancel')}
            </button>
          ) : (
            <a class="cv-icon-btn" href={session.cancel_url!}>
              {t('app.cancel')}
            </a>
          ))}
        <LanguageSwitch />
        <button type="button" class="cv-icon-btn" onClick={cycle} aria-label={t('app.theme.toggle')} title={t('app.theme.toggle')}>
          {theme === 'dark' ? '☾' : theme === 'light' ? '☀' : '◑'}
        </button>
      </div>
    </footer>
  );
}
